/* import __COLOCATED_TEMPLATE__ from './button-back-arrow.hbs'; */
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['dialog__header__previous', 'button--tertiary'],
  tagName: 'button',
  // Prevent from submitting forms via default `submit` type
  type: 'button',
  attributeBindings: ['type', 'data-test-dialog-header-back-button'],
  'data-test-dialog-header-back-button': true
});